/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData model module.
 * @module model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData} The populated <code>PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('createdHvh')) {
                obj['createdHvh'] = ApiClient.convertToType(data['createdHvh'], 'Number');
            }
            if (data.hasOwnProperty('createdPer')) {
                obj['createdPer'] = ApiClient.convertToType(data['createdPer'], 'Number');
            }
            if (data.hasOwnProperty('createdXper')) {
                obj['createdXper'] = ApiClient.convertToType(data['createdXper'], 'Number');
            }
            if (data.hasOwnProperty('createdUsdt')) {
                obj['createdUsdt'] = ApiClient.convertToType(data['createdUsdt'], 'Number');
            }
            if (data.hasOwnProperty('createdArb')) {
                obj['createdArb'] = ApiClient.convertToType(data['createdArb'], 'Number');
            }
            if (data.hasOwnProperty('consumedHvh')) {
                obj['consumedHvh'] = ApiClient.convertToType(data['consumedHvh'], 'Number');
            }
            if (data.hasOwnProperty('consumedPer')) {
                obj['consumedPer'] = ApiClient.convertToType(data['consumedPer'], 'Number');
            }
            if (data.hasOwnProperty('consumedXper')) {
                obj['consumedXper'] = ApiClient.convertToType(data['consumedXper'], 'Number');
            }
            if (data.hasOwnProperty('consumedUsdt')) {
                obj['consumedUsdt'] = ApiClient.convertToType(data['consumedUsdt'], 'Number');
            }
            if (data.hasOwnProperty('consumedArb')) {
                obj['consumedArb'] = ApiClient.convertToType(data['consumedArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['targetDate'] = undefined;

/**
 * @member {Number} createdHvh
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['createdHvh'] = undefined;

/**
 * @member {Number} createdPer
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['createdPer'] = undefined;

/**
 * @member {Number} createdXper
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['createdXper'] = undefined;

/**
 * @member {Number} createdUsdt
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['createdUsdt'] = undefined;

/**
 * @member {Number} createdArb
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['createdArb'] = undefined;

/**
 * @member {Number} consumedHvh
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['consumedHvh'] = undefined;

/**
 * @member {Number} consumedPer
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['consumedPer'] = undefined;

/**
 * @member {Number} consumedXper
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['consumedXper'] = undefined;

/**
 * @member {Number} consumedUsdt
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['consumedUsdt'] = undefined;

/**
 * @member {Number} consumedArb
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.prototype['consumedArb'] = undefined;






export default PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData;

